import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface NextBestActionFiles {
  parityFile: File | null;
  salesforceFile: File | null;
  vnsFile: File | null;
  setParityFile: (file: File | null) => void;
  setSalesforceFile: (file: File | null) => void;
  setVnsFile: (file: File | null) => void;
  clearFiles: () => void;
}

const NextBestActionFilesContext = createContext<NextBestActionFiles>({
  parityFile: null,
  salesforceFile: null,
  vnsFile: null,
  setParityFile: () => {},
  setSalesforceFile: () => {},
  setVnsFile: () => {},
  clearFiles: () => {},
});

export function NextBestActionFilesProvider({ children }: { children: React.ReactNode }) {
  const [parityFile, setParityFile] = useState<File | null>(null);
  const [salesforceFile, setSalesforceFile] = useState<File | null>(null);
  const [vnsFile, setVnsFile] = useState<File | null>(null);

  const clearFiles = useCallback(() => {
    setParityFile(null);
    setSalesforceFile(null);
    setVnsFile(null);
  }, []);

  const value = useMemo(
    () => ({ parityFile, salesforceFile, vnsFile, setParityFile, setSalesforceFile, setVnsFile, clearFiles }),
    [parityFile, salesforceFile, vnsFile, clearFiles],
  );

  return <NextBestActionFilesContext.Provider value={value}>{children}</NextBestActionFilesContext.Provider>;
}

export function useNextBestActionFiles() {
  return useContext(NextBestActionFilesContext);
}
